import {
  IconAngleRight,
  IconCalculator,
  IconEnvelopeAlt,
  IconSearch,
} from '@maia/icons';
import { ButtonLink, InfoCard, PageHeader } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/edit-insurance/$customer/cart/$cart/success',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { customer } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De wijzigings order is ingediend"
        description="Dit kan de klant verwachten"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Bevestigingsmail"
              description="Binnen enkele minuten ontvangt de klant een bevestigings email."
            />
          </li>
          <li>
            <InfoCard
              icon={IconCalculator}
              title="Teruggave"
              description="Eventuele teruggave zal worden berekend en aan de klant gecommuniceerd worden"
            />
          </li>
          <li>
            <InfoCard
              icon={IconSearch}
              title="Eventuele Herbeoordeling "
              description="We beoordelen de verzekering opnieuw en nemen contact met de klant op. Ondertussen blijft de verzekering gewoon van kracht."
            />
          </li>
        </ul>
        <div className="col-span-full flex justify-end">
          <ButtonLink
            to="/customers/$guid"
            params={{ guid: customer }}
            intent="primary"
            iconRight={IconAngleRight}
          >
            Naar klant
          </ButtonLink>
        </div>
      </div>
      <div className="area-page-sidebar invisible" />
    </div>
  );
}
